import styled from 'styled-components';

import DefSelect from 'components/SelectNew';

export const Select = styled(DefSelect)`
  width: ${({ $width }) => $width}px;
  font-size: var(--font-size13);
  margin-top: 28px;
`;
